import { Flex, Box, Text, Circle } from '@chakra-ui/react';

const steps = ['Device Validation', 'Company Details', 'Compliance'];

const Stepper = ({ step }) => {
  return (
    <Flex mb={8} align="center" justify="space-between">
      {steps.map((label, index) => {
        const stepNumber = index + 1;
        const isActive = step >= stepNumber;

        return (
          <Flex key={index} direction="column" align="center" flex="1">
            <Circle
              size="35px"
              bg={isActive ? 'blue.500' : 'gray.300'}
              color="white"
              mb={2}
            >
              {stepNumber}
            </Circle>
            <Text fontSize="sm" color={isActive ? 'blue.600' : 'gray.500'}>
              {label}
            </Text>
          </Flex>
        );
      })}
    </Flex>
  );
};

export default Stepper;
